import React, { useState } from "react";
import { ChevronRight, ChevronDown, Search } from "lucide-react";

// Import all data
const categoryData = [
  {
    id: "1",
    subtitle_arab: "ﺗﻜﺒﻴﺮﺓ ﺍﻹﺣﺮﺍﻡ",
    subtitle_id: "Takbiratul ihram",
    subtitle_en: "Takbiratul ihram",
    path_next: "/list/takbir",
  },
  {
    id: "2",
    subtitle_arab: "الإفتتاح",
    subtitle_id: "Iftitah",
    subtitle_en: "Iftitah",
    path_next: "/list/iftitah",
  },
  {
    id: "3",
    subtitle_arab: "تعاوذ",
    subtitle_id: "Ta'awwudz",
    subtitle_en: "Ta'awwudz",
    path_next: "/list/taawudz",
  },
  {
    id: "4",
    subtitle_arab: "ٱلۡفَاتِحَةِ",
    subtitle_id: "Al Fatihah",
    subtitle_en: "Al Fatihah",
    path_next: "/list/fatihah",
  },
  {
    id: "5",
    subtitle_arab: "رُكوع",
    subtitle_id: "Rukuk",
    subtitle_en: "Ruku' (Bowing)",
    path_next: "/list/rukuk",
  },
  {
    id: "6",
    subtitle_arab: "اِعْتِدَال",
    subtitle_id: "Iktidal",
    subtitle_en: "Iktidal",
    path_next: "/list/iktidal",
  },
  {
    id: "7",
    subtitle_arab: "سُجدة",
    subtitle_id: "Sujud",
    subtitle_en: "Sujud (Prostration)",
    path_next: "/list/sujud",
  },
  {
    id: "8",
    subtitle_arab: "جلس",
    subtitle_id: "Duduk Diantara 2 Sujud",
    subtitle_en: "Between Two Sujud",
    path_next: "/list/duduk",
  },
  {
    id: "9",
    subtitle_arab: "تَشَهُّد",
    subtitle_id: "Tasyahud",
    subtitle_en: "Tasyahud",
    path_next: "/list/tasyahud",
  },
  {
    id: "10",
    subtitle_arab: "صَلَوَات",
    subtitle_id: "Sholawat",
    subtitle_en: "Salawat",
    path_next: "/list/salawat",
  },
  {
    id: "11",
    subtitle_arab: "دعاء بعد تَشَهُّد",
    subtitle_id: "Doa perlindungan",
    subtitle_en: "Protection Dua",
    path_next: "/list/perlindungan",
  },
  {
    id: "12",
    subtitle_arab: "السلام",
    subtitle_id: "Salam",
    subtitle_en: "Salam",
    path_next: "/list/salam",
  },
];

const detailedData = {
  iftitah: [
    {
      id: "1",
      doa: "اللَّهُمَّ",
      irob: "منادى بحذف حرف النداء مبني على الضم في محل نصب و تقديره يا الله والميم المشددة عوض عن حرف النداء",
      subtitle_id: "Ya Allah",
      subtitle_en: "O Allah",
    },
    {
      id: "2",
      doa: "بَاعِدْ",
      irob: "فعل أمر مبني على السكون في محل جزم وفاعله ضمير مستتر فيه وجوبا تقديره أنت",
      subtitle_id: "jauhkanlah",
      subtitle_en: "distance",
    },
    {
      id: "3",
      doa: "بَيْني",
      irob: "ظرف المكان منصوب وعلامة نصبه فتحة مقدرة على ما قبل الياء المتكلم والياء ضمير متصل مبني على السكون في محل جر مضاف إليه",
      subtitle_id: "antara aku",
      subtitle_en: "between me",
    },
    {
      id: "4",
      doa: "وَ",
      irob: "الواو حرف عطف مبني على الفتح",
      subtitle_id: "dan",
      subtitle_en: "and",
    },
    {
      id: "5",
      doa: "بَيْنَ",
      irob: "ظرف المكان منصوب وعلامة نصبه فتحة ظاهرة في آخره وهو مضاف",
      subtitle_id: "antara",
      subtitle_en: "between",
    },
    {
      id: "6",
      doa: "خَطَايَايَ",
      irob: "خطايا مضاف إليه مجرور وعلامة جره كسرة مقدرة على الألف منع من ظهورها التعذر والياء ضمير متصل مبني على الفتح في محل جر مضاف إليه",
      subtitle_id: "kesalahanku",
      subtitle_en: "my sins",
    },

    {
      id: "7",
      doa: "كَمَا",
      irob: "الكاف حرف جر وما اسم موصول مبني علىالسكون في محل جر مجرور بالكاف",
      subtitle_id: "sebagaimana",
      subtitle_en: "as",
    },
    {
      id: "8",
      doa: "بَاعَدْتَ",
      irob: "فعل ماض مبني على السكون والتاء ضمير متصل مبني على الفتح في محل رفع فاعله",
      subtitle_id: "Engkau jauhkan",
      subtitle_en: "You have distanced",
    },
    {
      id: "9",
      doa: "بَيْنَ",
      irob: "ظرف المكان منصوب وعلامة نصبه فتحة ظاهرة في آخره وهو مضاف",
      subtitle_id: "antara",
      subtitle_en: "between",
    },
    {
      id: "10",
      doa: "المَشْرِقِ",
      irob: "مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "timur",
      subtitle_en: "east",
    },
    {
      id: "11",
      doa: "وَ",
      irob: "الواو حرف عطف مبني على الفتح",
      subtitle_id: "dan",
      subtitle_en: "and",
    },
    {
      id: "12",
      doa: "المَغْرِبِ",
      irob: "معطوف على المشرق مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "barat",
      subtitle_en: "west",
    },
    {
      id: "13",
      doa: "اللَّهُمَّ",
      irob: "منادى بحذف حرف النداء مبني على الضم في محل نصب و تقديره يا الله والميم المشددة عوض عن حرف النداء",
      subtitle_id: "Ya Allah",
      subtitle_en: "O Allah",
    },

    {
      id: "14",
      doa: "نقني",
      irob: "فعل أمر مبني على حذف حرف العلة في محل جزم وفاعله ضمير مستتر فيه وجوبا تقديره أنت والنون للوقاية والياء ضمير متصل مبني على السكون في محل نصب مفعول به",
      subtitle_id: "Sucikanlah aku",
      subtitle_en: "cleanse me",
    },
    {
      id: "15",
      doa: "مِنَ",
      irob: "حرف جر مبني على السكون",
      subtitle_id: "dari",
      subtitle_en: "from",
    },
    {
      id: "16",
      doa: "الخطايا",
      irob: "مجرور بمن وعلامة جره كسرة مقدرة على الألف منع من ظهورها التعذر",
      subtitle_id: "kesalahan",
      subtitle_en: "my sins",
    },
    {
      id: "17",
      doa: "كَمَا",
      irob: "الكاف حرف جر وما اسم موصول مبني على السكون في محل جر مجرور بالكاف",
      subtitle_id: "sebagaimana",
      subtitle_en: "as",
    },
    {
      id: "18",
      doa: "ينقى",
      irob: "فعل مضارع مبني للمجهول مرفوع وعلامة رفعه ضمة مقدرة على الألف منع من ظهورها التعذر",
      subtitle_id: "Disucikan",
      subtitle_en: "is cleaned",
    },
    {
      id: "19",
      doa: "الثَّوْبُ",
      irob: "نائب الفاعل مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "baju",
      subtitle_en: "garment",
    },
    {
      id: "20",
      doa: "الأَبْيَضُ",
      irob: "نعت للثوب مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "putih",
      subtitle_en: "white",
    },
    {
      id: "21",
      doa: "مِنَ",
      irob: "حرف جر مبني على السكون",
      subtitle_id: "dari",
      subtitle_en: "from",
    },
    {
      id: "22",
      doa: "الدَّنَسِ",
      irob: "مجرور بمن وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "kotoran",
      subtitle_en: "dirt",
    },

    {
      id: "23",
      doa: "اللهُمَّ",
      irob: "منادى بحذف حرف النداء مبني على الضم في محل نصب و تقديره يا الله والميم المشددة عوض عن حرف النداء",
      subtitle_id: "Ya Allah",
      subtitle_en: "O Allah",
    },
    {
      id: "24",
      doa: "اغْسِلْ",
      irob: "فعل أمر مبني على السكون في محل جزم وفاعله ضمير مستتر فيه وجوبا تقديره أنت",
      subtitle_id: "cucilah",
      subtitle_en: "wash",
    },
    {
      id: "25",
      doa: "خَطَايَايَ",
      irob: "خطايا مفعول به منصوب وعلامة نصبه فتحة مقدرة على الألف منع من ظهورها التعذر والياء ضمير متصل مبني على الفتح في محل جر مضاف إليه",
      subtitle_id: "Kesalahanku",
      subtitle_en: "my sins",
    },
    {
      id: "26",
      doa: "بِالْمَاءِ",
      irob: " الباء حرف جر والماء مجرور بالباء وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Dengan air",
      subtitle_en: "with water",
    },
    {
      id: "27",
      doa: "وَ",
      irob: "الواو حرف عطف مبني على الفتح",
      subtitle_id: "dan",
      subtitle_en: "and",
    },
    {
      id: "28",
      doa: "الثَّلْجِ",
      irob: "معطوف على الماء مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "salju",
      subtitle_en: "snow",
    },
    {
      id: "29",
      doa: "وَ",
      irob: "الواو حرف عطف مبني على الفتح",
      subtitle_id: "dan",
      subtitle_en: "and",
    },
    {
      id: "30",
      doa: "البَرَدِ",
      irob: "معطوف على الماء مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "air dingin",
      subtitle_en: "hail",
    },
  ],
  taawudz: [
    {
      id: "1",
      doa: "أَعُوذُ",
      irob: "فعل مضارع مرفوع وعلامة رفعه ضمة ظاهرة في آخره وفاعله ضمير مستتر فيه وجوبا تقديره أنا",
      subtitle_id: "Aku berlindung",
      subtitle_en: "I seek protection",
    },
    {
      id: "2",
      doa: "بالله",
      irob: "الباء حرف جر والله لفظ الجلالة مجرور بالباء وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "kepada Allah",
      subtitle_en: "in Allah",
    },
    {
      id: "3",
      doa: "السَّمِيعِ",
      irob: "نعت الله مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Yang Maha Mendengar",
      subtitle_en: "The Hearer",
    },
    {
      id: "4",
      doa: "العَلِيمِ",
      irob: "نعت الله مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Yang Maha Mengetahui",
      subtitle_en: "The Knowledgeable",
    },
    {
      id: "5",
      doa: "مِنَ الشَّيْطَانِ",
      irob: "من حرف جر والشيطان مجرور بمن وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "dari syaithan",
      subtitle_en: "from syaithan",
    },
    {
      id: "6",
      doa: "الرَّجيْمِ",
      irob: "نعت للشيطان مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Yang terkutuk",
      subtitle_en: "The rejected",
    },
  ],
  rukuk: [
    {
      id: "1",
      doa: "سُبْحَانَ",
      irob: "مفعول مطلق منصوب وعلامة نصبه فتحة ظاهرة في آخره وهو مضاف",
      subtitle_id: "Maha Suci",
      subtitle_en: "The Most Holly",
    },
    {
      id: "2",
      doa: "ربّي",
      irob: "ربّ مضاف إليه مجرور وعلامة جره كسرة مقدرة على ما قبل ياء المتكلم والياء ضمير متصل مبني على الفتح في محل جر مضاف إليه",
      subtitle_id: "Robbku",
      subtitle_en: "my Lord",
    },
    {
      id: "3",
      doa: "الْعَظِيمِ",
      irob: "نعت لربي مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Maha Agung",
      subtitle_en: "The Incompably Great",
    },
    {
      id: "4",
      doa: "وَبِحَمْدِهِ",
      irob: "الواو حرف عطف والباء حرف جر وحمد مجرور بالباء وعلامة جره كسرة ظاهرة في آخره وهو مضاف والهاء ضمير متصل مبني على الكسر في محل جر مضاف إليه",
      subtitle_id: "Dan dengan memujiNya",
      subtitle_en: "and by praise Allah ",
    },
  ],
  iktidal: [
    {
      id: "1",
      doa: "سَمِعَ",
      irob: "فعل ماض مبني على الفتح",
      subtitle_id: "Telah mendengar",
      subtitle_en: "heard",
    },
    {
      id: "2",
      doa: "الله",
      irob: "لفظ الجلالة فاعل مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "Allah",
      subtitle_en: "Allah",
    },
    {
      id: "3",
      doa: "لِمَنْ",
      irob: "اللام حرف جر ومن اسم موصول مبني على السكون في محل جر مجرور باللام",
      subtitle_id: "bagi siapa",
      subtitle_en: "the one who",
    },
    {
      id: "4",
      doa: "حَمدَهُ",
      irob: "فعل ماض مبني على الفتح وفاعله ضمير مستتر فيه جوازا تقديره هو يعودعلى من والهاء ضمير متصل مبني على الضم في محل نصب مفعول به",
      subtitle_id: "memujiNya",
      subtitle_en: "praised Him",
    },
    {
      id: "5",
      doa: "رَبَّنَا",
      irob: "منادى منصوب وعلامة نصبه فتحة ظاهرة في آخره وهو مضاف ونا ضمير متصل مبني على السكون في محل جر مضاف إليه",
      subtitle_id: "Robb kami",
      subtitle_en: "Our Lord",
    },
    {
      id: "6",
      doa: "لك",
      irob: "اللام حرف جر والكاف ضمير متصل مبني على الفتح في محل جر مجرور باللام و الجار والمجرور متعلقان بمحذوف تقديره كائن في محل رفع خبر مقدم",
      subtitle_id: "bagiMu",
      subtitle_en: "to You",
    },
    {
      id: "7",
      doa: "الحمدُ",
      irob: "مبتدأ مؤخر مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "segala pujian",
      subtitle_en: "all praise",
    },
  ],
  sujud: [
    {
      id: "1",
      doa: "سُبْحَانَ",
      irob: "مفعول مطلق منصوب وعلامة نصبه فتحة ظاهرة في آخره وهو مضاف",
      subtitle_id: "Maha Suci",
      subtitle_en: "The Most Holly",
    },
    {
      id: "2",
      doa: "ربّي",
      irob: "ربّ مضاف إليه مجرور وعلامة جره كسرة مقدرة على ما قبل ياء المتكلم والياء ضمير متصل مبني على الفتح في محل جر مضاف إليه",
      subtitle_id: "Robbku",
      subtitle_en: "My Lord",
    },
    {
      id: "3",
      doa: "الْاعلئ",
      irob: "نعت لربي مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Maha Tinggi",
      subtitle_en: "The Highest",
    },
    {
      id: "4",
      doa: "وَبِحَمْدِهِ",
      irob: "الواو حرف عطف والباء حرف جر وحمد مجرور بالباء وعلامة جره كسرة ظاهرة في آخره وهو مضاف والهاء ضمير متصل مبني على الكسر في محل جر مضاف إليه",
      subtitle_id: "dan dengan memujiNya",
      subtitle_en: "and by praise Allah ",
    },
  ],
  tasyahud: [
    {
      id: "1",
      doa: "التَّحِيَّاتُ",
      irob: "مبتدأ مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "Segala penghormatan",
      subtitle_en: "All greetings",
    },
    {
      id: "2",
      doa: "المُبَارَكَاتُ",
      irob: "معطوف على التحيات مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "Keberkahan",
      subtitle_en: "all bleasing",
    },
    {
      id: "3",
      doa: "الصَّلَوَاتُ",
      irob: "معطوف على التحيات مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "Shalawat",
      subtitle_en: "all prayers",
    },
    {
      id: "4",
      doa: "الطَّيِّبَاتُ",
      irob: "معطوف على التحيات مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "Kebaikan",
      subtitle_en: "all good things",
    },
    {
      id: "5",
      doa: "لِلَّٰهِ",
      irob: "اللام حرف جر والله لفظ الجلالة مجرور باللام وعلامة جره كسرة ظاهرة في آخره الجار والمجرور متعلقان بمحذوف تقديره كائن في محل رفع خبر المبتدأ",
      subtitle_id: "kepada Allah",
      subtitle_en: "are for Allah",
    },
    {
      id: "6",
      doa: "السَّلَامُ",
      irob: "مبتدأ مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "Keselamatan",
      subtitle_en: "peace",
    },

    {
      id: "7",
      doa: "عَلَيْكَ",
      irob: "على حرف جر والكاف ضمير متصل مبني على الفتح في محل جر مجرور بعلى  والجار والمجرور متعلقان بمحذوف تقديره كائن في محل رفع خبر المبتدأ",
      subtitle_id: "atasmu",
      subtitle_en: "be upon you",
    },
    {
      id: "8",
      doa: "أَيُّهَا",
      irob: "منادى مبني على الضم في محل نصب وها حرف التنبيه",
      subtitle_id: "wahai",
      subtitle_en: "O",
    },
    {
      id: "9",
      doa: "النَّبِيُّ",
      irob: "بدل من أي مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "Nabi",
      subtitle_en: "Prophet",
    },
    {
      id: "10",
      doa: "وَرَحْمَةُ",
      irob: "الواو حرف عطف ورحمة معطوف على السلام مرفوع وعلامة رفعه ضمة ظاهرة في آخره وهو مضاف",
      subtitle_id: "dan rahmat",
      subtitle_en: "and the mercy",
    },
    {
      id: "11",
      doa: "الله",
      irob: "لفظ الجلالة مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Allah",
      subtitle_en: "Allah",
    },
    {
      id: "12",
      doa: "وَبَرَكَاتُهُ",
      irob: "الواو حرف عطف وبركاته معطوف على السلام مرفوع وعلامة رفعه ضمة ظاهرة في آخره وهو مضاف والهاء ضمير متصل مبني على الضم في محل جر مضاف إليه",
      subtitle_id: "dan keberkahanNya",
      subtitle_en: "and His blessings",
    },
    {
      id: "13",
      doa: "السَّلَامُ",
      irob: "مبتدأ مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "keselamatan",
      subtitle_en: "peace",
    },

    {
      id: "14",
      doa: "عَلَيْنَا",
      irob: "على حرف جر ونا ضمير متصل مبني على السكون في محل جر مجرور بعلى والجار والمجرور متعلقان بمحذوف تقديره كائن في محل رفع خبر المبتدأ",
      subtitle_id: "atas kami",
      subtitle_en: "be upon us",
    },
    {
      id: "15",
      doa: "وَعَلَى عِبَادِ",
      irob: "الواو حرف عطف وعلى حرف جر وعباد مجرور بعلى وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "dan atas para hamba",
      subtitle_en: "and upon servants",
    },
    {
      id: "16",
      doa: "الله",
      irob: "لفظ الجلالة مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Allah",
      subtitle_en: "Allah",
    },
    {
      id: "17",
      doa: "الصَّالِحِينَ",
      irob: "نعت لعباد مجرور وعلامة جره الياء نيابة عن الكسرة لأنه جمع مذكر سالم",
      subtitle_id: "yang shalih",
      subtitle_en: "righteous",
    },
    {
      id: "18",
      doa: "أَشْهَدُ",
      irob: "فعل مضارع مرفوع وعلامة رفعه ضمة ظاهرة في آخره وفاعله ضمير مستتر فيه وجوبا تقديره أنا",
      subtitle_id: "Aku bersaksi",
      subtitle_en: "I bear witness",
    },
    {
      id: "20",
      doa: "أَنْ لَا إِلَهَ",
      irob: "أن حرف توكيد ونصب مخففة من أن واسمها ضمير الشأن المحذوف وتقديره أنه ولا نافية للجنس تعمل عمل إن وإله اسم لا مبني على الفتح في محل نصب وخبرها محذوف تقديره حق",
      subtitle_id: "Bahwa tiada tuhan",
      subtitle_en: "that there is no God",
    },

    {
      id: "21",
      doa: "إلا الله",
      irob: "إلا حرف الاستثناء ملغاة والله لفظ الجلالة بدل من حق مرفوع وعلامة رفعه ضمة ظاهرة في آخره والجملة من لا واسمها وخبرها في محل رفع خبر أن",
      subtitle_id: "Selain Allah",
      subtitle_en: "but Allah",
    },
    {
      id: "22",
      doa: "وَأَشْهَدُ",
      irob: "الواو حرف عطف وأشهد فعل مضارع مرفوع وعلامة رفعه ضمة ظاهرة في آخره وفاعله ضمير مستتر فيه وجوبا تقديره أنا",
      subtitle_id: "dan aku bersaksi",
      subtitle_en: "and I bear witness",
    },
    {
      id: "23",
      doa: "أنَّ مُحَمَّدًا",
      irob: "أن حرف توكيد ونصب ومحمدا اسم أن منصوب وعلامة نصبه فتحة ظاهرة في آخره",
      subtitle_id: "bahwa Muhammad",
      subtitle_en: "that Muhammad",
    },
    {
      id: "24",
      doa: "رَسُولُ",
      irob: "خبر أن مرفوع وعلامة رفعه ضمة ظاهرة في آخره وهو مضاف",
      subtitle_id: "utusan",
      subtitle_en: "messenger",
    },
    {
      id: "25",
      doa: "الله",
      irob: "لفظ الجلالة مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Allah",
      subtitle_en: "Allah",
    },
  ],
  salawat: [
    {
      id: "1",
      doa: "اللهم",
      irob: "منادى بحذف حرف النداء مبني على الضم في محل نصب و تقديره يا الله والميم المشددة عوض عن حرف النداء",
      subtitle_id: "Ya Allah",
      subtitle_en: "O My Lord",
    },
    {
      id: "2",
      doa: "صَلِّ",
      irob: "فعل الأمر للدعاء مبني على حذف حرف العلة في محل جزم وفاعله ضمير مستتر فيه وجوبا تقديره أنت",
      subtitle_id: "berilah shalawat",
      subtitle_en: "send shalawat",
    },
    {
      id: "3",
      doa: "عَلَى محمد",
      irob: "على حرف جر ومحمد مجرور بعلى وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "atas Muhammad",
      subtitle_en: "upon Muhammad",
    },

    {
      id: "4",
      doa: "وَعَلَى آلِ",
      irob: "الواو حرف عطف وعلى حرف جر وآل مجرور بعلى وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "dan atas keluarga",
      subtitle_en: "and upon the family",
    },
    {
      id: "5",
      doa: " مُحَمَّدٍ",
      irob: "مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Muhammad",
      subtitle_en: "Muhammad",
    },
    {
      id: "6",
      doa: "كَمَا",
      irob: "الكاف حرف جر وما اسم موصول مبني على السكون في محل جر مجرور بالكاف",
      subtitle_id: "sebagaimana",
      subtitle_en: "as",
    },

    {
      id: "7",
      doa: "صَلَّيْتَ",
      irob: "فعل ماض مبني على السكون والتاء ضمير متصل مبني على الفتح في محل رفع فاعله",
      subtitle_id: "engkau berikan shalawat",
      subtitle_en: "you send shalawat",
    },
    {
      id: "8",
      doa: "عَلَى إِبْرَاهِيمَ",
      irob: "على حرف جر وإبراهيم مجرور بعلى وعلامة جره فتحة نيابة عن الكسرة لأنه الاسم الذي لا ينصرف",
      subtitle_id: "atas Ibrahim",
      subtitle_en: "upon Ibrahim",
    },
    {
      id: "9",
      doa: "وَعَلَى آلِ",
      irob: "الواو حرف عطف وعلى حرف جر وآل مجرور بعلى وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "dan atas keluarga",
      subtitle_en: "and upon the family",
    },
    {
      id: "10",
      doa: "إِبْرَاهِيمَ",
      irob: "مضاف إليه مجرور وعلامة جره فتحة نيابة عن الكسرة لأنه الاسم الذي لا ينصرف",
      subtitle_id: "Ibrahim",
      subtitle_en: "Ibrahim",
    },
    {
      id: "11",
      doa: "وَبَارِك",
      irob: "الواو حرف عطف وبارك فعل الأمر للدعاء مبني على السكون في محل جزم وفاعله ضمير مستتر فيه وجوبا",
      subtitle_id: "dan berkahilah",
      subtitle_en: "and bless",
    },
    {
      id: "12",
      doa: "عَلَى مُحَمَّدٍ",
      irob: "على حرف جر ومحمد مجرور بعلى وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "atas Muhammad",
      subtitle_en: "upon Muhammad",
    },
    {
      id: "13",
      doa: "وَعَلَى آلِ",
      irob: "الواو حرف عطف وعلى حرف جر وآل مجرور بعلى وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "dan atas keluarga",
      subtitle_en: "and upon the family",
    },

    {
      id: "14",
      doa: "مُحَمَّدٍ",
      irob: "مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Muhammad",
      subtitle_en: "Muhammad",
    },
    {
      id: "15",
      doa: "كَمَا",
      irob: "الكاف حرف جر وما اسم موصول مبني على السكون في محل جر مجرور بالكاف",
      subtitle_id: "sebagaimana",
      subtitle_en: "as",
    },
    {
      id: "16",
      doa: "بَارَكْتَ",
      irob: "فعل ماض مبني على السكون والتاء ضمير متصل مبني على الفتح في محل رفع فاعله",
      subtitle_id: "engkau berkahi",
      subtitle_en: "you have blessed",
    },
    {
      id: "17",
      doa: "عَلَى إِبْرَاهِيمَ",
      irob: "على حرف جر وإبراهيم مجرور بعلى وعلامة جره فتحة نيابة عن الكسرة لأنه الاسم الذي لا ينصرف",
      subtitle_id: "atas Ibrahim",
      subtitle_en: "upon Ibrahim",
    },
    {
      id: "18",
      doa: "وَعَلَى آلِ",
      irob: "الواو حرف عطف وعلى حرف جر وآل مجرور بعلى وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "dan atas keluarga",
      subtitle_en: "and upon the family",
    },
    {
      id: "19",
      doa: "إِبْرَاهِيمَ",
      irob: "مضاف إليه مجرور وعلامة جره فتحة نيابة عن الكسرة لأنه الاسم الذي لا ينصرف",
      subtitle_id: "Ibrahim",
      subtitle_en: "Ibrahim",
    },

    {
      id: "20",
      doa: "إِنَّكَ",
      irob: "إن حرف توكيد ونصب والكاف ضمير متصل مبني على الفتح في محل نصب اسم إنّ",
      subtitle_id: "sungguh, Engkau",
      subtitle_en: "indeed, You",
    },
    {
      id: "21",
      doa: "حميد",
      irob: "خبر إن مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "Maha Terpuji",
      subtitle_en: "The Praiseworthy",
    },
    {
      id: "22",
      doa: "مجيد",
      irob: "خبر إن مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "Maha Mulia",
      subtitle_en: "The Glorious",
    },
  ],
  perlindungan: [
    {
      id: "1",
      doa: "اللّهُمَّ",
      irob: "منادى بحذف حرف النداء مبني على الضم في محل نصب و تقديره يا الله والميم المشددة عوض عن حرف النداء",
      subtitle_id: "Ya Allah",
      subtitle_en: "O Allah",
    },
    {
      id: "2",
      doa: "إِنِّي",
      irob: "إن حرف توكيد ونصب والياء ضمير متصل مبني على السكون في محل نصب اسم إن",
      subtitle_id: "sesungguhnya aku",
      subtitle_en: "Indeed",
    },
    {
      id: "3",
      doa: "أعوذ",
      irob: "فعل مضارع مرفوع وعلامة رفعه ضمة ظاهرة في آخره وفاعله ضمير مستتر فيه وجوبا تقديره أنا والجملة من الفعل والفاعل في محل رفع خبر إن",
      subtitle_id: "aku berlindung",
      subtitle_en: "I seek protection",
    },
    {
      id: "4",
      doa: "بِكَ",
      irob: "الباء حرف جر والكاف ضمير متصل مبني على الفتح في محل جر مجرور بالباء",
      subtitle_id: "kepadamu",
      subtitle_en: "in You",
    },
    {
      id: "5",
      doa: "مِنْ عَذَابٍ",
      irob: "من حرف جر وعذاب مجرور بمن وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "dari adzab",
      subtitle_en: "by punishment",
    },
    {
      id: "6",
      doa: "جَهَنَّمَ",
      irob: "مضاف إليه مجرور وعلامة جره الفتحة نيابة عن الكسرة لأنه الاسم الذي لا ينصرف",
      subtitle_id: "jahannam",
      subtitle_en: "hell",
    },
    {
      id: "7",
      doa: "وَمِنْ عَذَابٍ",
      irob: "الواو حرف عطف ومن حرف جر وعذاب مجرور بمن وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "dan dari adzab",
      subtitle_en: "and from torment",
    },
    {
      id: "8",
      doa: "القَبْرِ",
      irob: "مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "kubur",
      subtitle_en: "grave",
    },
    {
      id: "9",
      doa: "وَمِنْ فِتْنَةِ",
      irob: "الواو حرف عطف ومن حرف جر وفتنة مجرور بمن وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "dan dari fitnah",
      subtitle_en: "and from trial",
    },
    {
      id: "10",
      doa: "المَحْيَا",
      irob: "مضاف إليه مجرور وعلامة جره كسرة مقدرة على الألف منع من ظهورها التعذر",
      subtitle_id: "kehidupan",
      subtitle_en: "life",
    },
    {
      id: "11",
      doa: "وَالْمَمَاتِ",
      irob: "الواو حرف عطف والممات معطوف على المحيا مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "dan kematian",
      subtitle_en: "and death",
    },
    {
      id: "12",
      doa: "وَمِنْ شَرِ",
      irob: "الواو حرف عطف ومن حرف جر وشر مجرور بمن وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "dan dari keburukan",
      subtitle_en: "and from evil",
    },
    {
      id: "13",
      doa: "فِتْنَةِ",
      irob: "مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "fitnah",
      subtitle_en: "trial",
    },
    {
      id: "14",
      doa: "المَسِيحِ",
      irob: "مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Al masih",
      subtitle_en: "Al masih",
    },
    {
      id: "15",
      doa: "الدَّجَّالِ",
      irob: "بدل من المسيح مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Dajjal",
      subtitle_en: "Dajjal",
    },
  ],
  salam: [
    {
      id: "1",
      doa: "السلام",
      irob: " مبتدأ مرفوع وعلامة رفعه ضمة ظاهرةفي آخره",
      subtitle_id: "Keselamatan",
      subtitle_en: "Peace",
    },
    {
      id: "2",
      doa: "عَلَيْكُمْ",
      irob: "على حرف جر والكاف ضمير متصل مبني على الضمم في محل جر مجرور باللام والميم علامة الجمع والجار والمجرور متعلقان بمحذوف تقديره كائن في محل رفع خبر المبتدأ",
      subtitle_id: "Atas kalian",
      subtitle_en: "be all of you",
    },
    {
      id: "3",
      doa: "وَرَحْمَةُ",
      irob: "الواو حرف عطف ورحمة معطوف على السلام مرفوع وعلامة رفعه ضمة ظاهرة في آخره وهو مضاف",
      subtitle_id: "Dan rahmat",
      subtitle_en: "and Mercy",
    },
    {
      id: "4",
      doa: "الله",
      irob: "مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Allah",
      subtitle_en: "Allah",
    },
  ],
  takbir: [
    {
      id: "1",
      doa: "الله",
      irob: "لفظ الجلالة مبتدأ مرفوع بالابتداء وعلامةرفعه ضمة ظاهرة في آخره",
      subtitle_id: "Allah",
      subtitle_en: "Allah",
    },
    {
      id: "2",
      doa: "أَكْبَرُ",
      irob: "خبر المبتدأ مرفوع وعلامة رفعه ضمة ظاهرةفي آخره",
      subtitle_id: "Maha Besar",
      subtitle_en: "The Greatest",
    },
  ],
  duduk: [
    {
      id: "1",
      doa: "رَبِّ",
      irob: "منادى مضاف إلي ياء المتكلم المحذوفة للتخفيف",
      subtitle_id: "Ya Tuhanku",
      subtitle_en: "O My Lord",
    },
    {
      id: "2",
      doa: "اغْفِرْ",
      irob: "فعل أمر مبني على السكون في محل جزم وفاعله ضمير مستتر فيه وجوبا تقديره أنت",
      subtitle_id: "ampunilah",
      subtitle_en: "forgive",
    },
    {
      id: "3",
      doa: "لي",
      irob: "اللام حرف جر والياء ضمير متصل مبني على السكون في محل جر مجرور باللام",
      subtitle_id: "aku",
      subtitle_en: "me",
    },
  ],
  fatihah: [
    {
      id: "1",
      doa: "بسم",
      irob: "الباء حرف جر واسم مجرور بالباء وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "Dengan nama",
      subtitle_en: "In the name",
    },
    {
      id: "2",
      doa: "الله",
      irob: "لفظ الجلالة مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Allah",
      subtitle_en: "Allah",
    },
    {
      id: "3",
      doa: "الرَّحْمنِ",
      irob: "نعت لله مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "yang Maha Pemurah",
      subtitle_en: "The Most Gracious",
    },
    {
      id: "4",
      doa: "الرَّحِيمِ",
      irob: "نعت لله مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "yang Maha Penyayang",
      subtitle_en: "The Most Merciful",
    },
    {
      id: "5",
      doa: "الحمد",
      irob: "مبتدأ مرفوع وعلامة رفعه ضمة ظاهرة في آخره",
      subtitle_id: "Segala puji",
      subtitle_en: "All praises",
    },
    {
      id: "6",
      doa: "لِلّٰهِ",
      irob: "اللام حرف جر والله لفظ الجلالة مجرور باللام وعلامة جره كسرة ظاهرة في آخره والجار والمجرور متعلقان بمحذوف تقديره كائن في محل رفع خبر المبتدأ",
      subtitle_id: "bagi Allah",
      subtitle_en: "to Allah",
    },
    {
      id: "7",
      doa: "رب",
      irob: "بدل من الله مجرور وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "Robb",
      subtitle_en: "Lord",
    },
    {
      id: "8",
      doa: "العَالَمِينَ",
      irob: "مضاف إليه مجرور وعلامة جره الياء نيابة عن الكسرة لأنه ملحق بجمع المذكر السالم",
      subtitle_id: "semesta alam",
      subtitle_en: "of the universe",
    },
    {
      id: "9",
      doa: "الرَّحْمنِ",
      irob: "بدل من الله مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Maha Pemurah",
      subtitle_en: "The Most Gracious",
    },
    {
      id: "10",
      doa: "الرَّحِيمِ",
      irob: "بدل من الله مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "Maha Penyayang",
      subtitle_en: "The Most Merciful",
    },
    {
      id: "11",
      doa: "مَالِكِ",
      irob: "بدل من الله مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "pemilik",
      subtitle_en: "master",
    },
    {
      id: "12",
      doa: "يوم",
      irob: "مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "hari",
      subtitle_en: "day",
    },
    {
      id: "13",
      doa: "الدِّيْنِ",
      irob: "مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "pembalasan",
      subtitle_en: "judgment",
    },
    {
      id: "14",
      doa: "إِيَّاكَ",
      irob: "ضمير منفصل مبني على الفتح في محل نصب مفعول به مقدم",
      subtitle_id: "hanya engkau",
      subtitle_en: "You alone",
    },
    {
      id: "15",
      doa: "نَعْبُدُ",
      irob: "فعل مضارع مرفوع وعلامة رفعه ضمة ظاهرة في آخره وفاعله ضمير مستتر فيه وجوبا تقديره نحن",
      subtitle_id: "kami sembah",
      subtitle_en: "we worship",
    },
    {
      id: "16",
      doa: "وَإِيَّاكَ",
      irob: "الواو حرف عطف و إياك ضمير منفصل مبني على الفتح في محل نصب مفعول به مقدم",
      subtitle_id: "dan hanya engkau",
      subtitle_en: "and You alone",
    },
    {
      id: "17",
      doa: "نستعين",
      irob: "فعل مضارع مرفوع وعلامة رفعه ضمة ظاهرة في آخره وفاعله ضمير مستتر فيه وجوبا تقديره نحن",
      subtitle_id: "kami mohon pertolongan",
      subtitle_en: "we ask for help",
    },
    {
      id: "18",
      doa: "اهدنا",
      irob: "فعل أمر مبني على حذف حرف العلة في محل جزم وفاعله ضمير مستتر فيه وجوبا تقديره أنت ونا ضمير متصل مبني على السكون في محل نصب مفعول به",
      subtitle_id: "tunjukilah kami",
      subtitle_en: "guide us",
    },
    {
      id: "19",
      doa: "الصِّرَاط",
      irob: "مفعول به ثان منصوب وعلامة نصبه فتحة ظاهرة في آخره",
      subtitle_id: "jalan",
      subtitle_en: "path",
    },
    {
      id: "20",
      doa: "المُسْتَقِيمَ",
      irob: "نعت للصراط منصوب وعلامة نصبه فتحة ظاهرة في آخره",
      subtitle_id: "yang lurus",
      subtitle_en: "straight",
    },
    {
      id: "21",
      doa: "صِرَاط",
      irob: "بدل من الصراط منصوب وعلامة نصبه فتحة ظاهرة في آخره وهو مضاف",
      subtitle_id: "jalan",
      subtitle_en: "path",
    },
    {
      id: "22",
      doa: "اللَّذِينَ",
      irob: "اسم موصول مبني على الفتح في محل جر مضاف إليه",
      subtitle_id: "yang",
      subtitle_en: "those",
    },
    {
      id: "23",
      doa: "أَنْعَمْتَ",
      irob: "فعل ماض مبني على السكون والتاء ضمير متصل مبني على الفتح في محل رفع فاعله",
      subtitle_id: "Kau beri kenikmatan",
      subtitle_en: "you have bestowed favors",
    },
    {
      id: "24",
      doa: "عَلَيْهِمْ",
      irob: "على حرف جر والهاء ضمير متصل مبني على الكسر في محل جر مجرور بعلى والميم علامة الجمع",
      subtitle_id: "atas mereka",
      subtitle_en: "on them",
    },
    {
      id: "25",
      doa: "غَيْر",
      irob: "نعت لللذين مجرور وعلامة جره كسرة ظاهرة في آخره وهو مضاف",
      subtitle_id: "bukan",
      subtitle_en: "not",
    },
    {
      id: "26",
      doa: "المَغْضُوبِ",
      irob: "مضاف إليه مجرور وعلامة جره كسرة ظاهرة في آخره",
      subtitle_id: "yang dimurkai",
      subtitle_en: "those who earned wrath",
    },
    {
      id: "27",
      doa: "عَلَيْهِمْ",
      irob: "على حرف جر والهاء ضمير متصل مبني على الكسر في محل جر مجرور بعلى والميم علامة الجمع",
      subtitle_id: "atas mereka",
      subtitle_en: "on themselves",
    },
    {
      id: "28",
      doa: "وَلَا الضَّالِّينَ",
      irob: "الواو حرف عطف ولا نافية والضالين معطوف على المغضوب مجرور وعلامة جره الياء نيابة عن الكسرة لأنه جمع المذكر السالم",
      subtitle_id: "dan bukan orang sesat",
      subtitle_en: "and not who go astray",
    },
  ],
};

const App = () => {
  const [expandedItems, setExpandedItems] = useState(new Set());
  const [searchQuery, setSearchQuery] = useState("");

  // Safe text highlighting function
  const highlightText = (text = "", query = "") => {
    if (!query.trim() || !text) return text;
    try {
      const regex = new RegExp(`(${query})`, "gi");
      const parts = text.toString().split(regex);

      return (
        <span>
          {parts.map((part, i) =>
            regex.test(part) ? (
              <mark key={i} className="bg-amber-200 text-amber-900">
                {part}
              </mark>
            ) : (
              <span key={i}>{part}</span>
            )
          )}
        </span>
      );
    } catch (e) {
      // Return original text if there's any error with regex
      return text;
    }
  };

  // Function to update search and expand matching items
  const handleSearch = (value) => {
    setSearchQuery(value);

    if (value) {
      // Get all matching category IDs
      const matchingIds = categoryData
        .filter((category) => {
          const searchLower = value.toLowerCase();

          // Check category titles
          const categoryMatches =
            (category.subtitle_arab || "")
              .toLowerCase()
              .includes(searchLower) ||
            (category.subtitle_id || "").toLowerCase().includes(searchLower) ||
            (category.subtitle_en || "").toLowerCase().includes(searchLower);

          // Check details
          const details = getDetailsForPath(category.path_next);
          const detailMatches = details.some(
            (detail) =>
              (detail.doa || "").toLowerCase().includes(searchLower) ||
              (detail.subtitle_id || "").toLowerCase().includes(searchLower) ||
              (detail.subtitle_en || "").toLowerCase().includes(searchLower) ||
              (detail.irob || "").toLowerCase().includes(searchLower)
          );

          return categoryMatches || detailMatches;
        })
        .map((category) => category.id);

      // Expand all matching categories
      setExpandedItems(new Set(matchingIds));
    } else {
      // Clear expanded items when search is empty
      setExpandedItems(new Set());
    }
  };

  const toggleExpanded = (id) => {
    const newExpandedItems = new Set(expandedItems);
    if (newExpandedItems.has(id)) {
      newExpandedItems.delete(id);
    } else {
      newExpandedItems.add(id);
    }
    setExpandedItems(newExpandedItems);
  };

  const getDetailsForPath = (path) => {
    const key = path.split("/").pop();
    return detailedData[key] || [];
  };

  // Filter categories based on search query
  const filteredCategories = categoryData.filter((category) => {
    if (!searchQuery) return true;

    const searchLower = searchQuery.toLowerCase();

    // Check category titles with null checks
    const categoryMatches =
      (category.subtitle_arab || "").toLowerCase().includes(searchLower) ||
      (category.subtitle_id || "").toLowerCase().includes(searchLower) ||
      (category.subtitle_en || "").toLowerCase().includes(searchLower);

    if (categoryMatches) return true;

    // Check details
    const details = getDetailsForPath(category.path_next);
    return details.some(
      (detail) =>
        (detail.doa || "").toLowerCase().includes(searchLower) ||
        (detail.subtitle_id || "").toLowerCase().includes(searchLower) ||
        (detail.subtitle_en || "").toLowerCase().includes(searchLower) ||
        (detail.irob || "").toLowerCase().includes(searchLower)
    );
  });

  return (
    <div className="min-h-screen bg-amber-50 p-6">
      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-amber-900 mb-2 font-serif m-3">
          ✧ IROB BACAAN SOLAT ✧
        </h1>
      </div>

      {/* Search Bar */}
      <div className="max-w-3xl mx-auto mb-6">
        <div className="relative">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Cari kata, terjemahan, atau irob..."
            className="w-full px-4 py-3 pl-12 bg-white border-2 border-amber-900 rounded-lg 
                     focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-amber-500
                     placeholder:text-amber-700/50 text-amber-900"
          />
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-amber-900/50" />
          {searchQuery && (
            <button
              onClick={() => handleSearch("")}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 text-amber-900/50 hover:text-amber-900"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {/* Prayer List */}
      <div className="max-w-3xl mx-auto space-y-4">
        {filteredCategories.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-amber-900 text-lg">
              tidak dapat menemukan "{searchQuery}"
            </p>
            <p className="text-amber-700 mt-2">coba cari istilah lain</p>
          </div>
        ) : (
          filteredCategories.map((item) => (
            <div
              key={item.id}
              className="bg-white border-2 border-amber-900 rounded-lg overflow-hidden"
            >
              {/* Main Category Header */}
              <div
                onClick={() => toggleExpanded(item.id)}
                className="group p-4 cursor-pointer hover:bg-amber-100 transition-all duration-300"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3 flex-1">
                    <span className="inline-flex items-center justify-center w-8 h-8 text-amber-900 bg-amber-200 rounded-full font-bold font-serif border-2 border-amber-900 flex-shrink-0">
                      {item.id}
                    </span>
                    <div className="flex-1">
                      <p className="text-2xl text-amber-900 font-arabic mb-1 text-right">
                        {highlightText(item.subtitle_arab, searchQuery)}
                      </p>
                      <p className="text-lg text-amber-800 font-medium">
                        {highlightText(item.subtitle_en, searchQuery)}
                      </p>
                      <p className="text-sm text-amber-700">
                        {highlightText(item.subtitle_id, searchQuery)}
                      </p>
                    </div>
                  </div>
                  {expandedItems.has(item.id) ? (
                    <ChevronDown className="w-6 h-6 text-amber-900" />
                  ) : (
                    <ChevronRight className="w-6 h-6 text-amber-900 group-hover:translate-x-1 transition-transform duration-300" />
                  )}
                </div>
              </div>

              {/* Expanded Details */}
              {expandedItems.has(item.id) && (
                <div className="border-t-2 border-amber-900 bg-amber-50/50">
                  <div className="p-4 space-y-4">
                    {getDetailsForPath(item.path_next).map((detail) => (
                      <div
                        key={detail.id}
                        className="bg-white p-4 rounded-lg border-2 border-amber-900/50 shadow-[2px_2px_0px_0px_rgba(120,53,15,0.5)]"
                      >
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <p className="text-2xl text-amber-900 font-arabic text-right mb-2 leading-loose">
                              {highlightText(detail.doa, searchQuery)}
                            </p>
                            <p className="text-sm text-amber-800 font-medium mb-1">
                              {highlightText(detail.subtitle_en, searchQuery)}
                            </p>
                            <p className="text-sm text-amber-700">
                              {highlightText(detail.subtitle_id, searchQuery)}
                            </p>
                          </div>
                          <div className="border-t md:border-t-0 md:border-l border-amber-900/20 md:pl-4 pt-4 md:pt-0">
                            <h4 className="text-xs text-amber-700 uppercase tracking-wide mb-2">
                              Detail I'robnya:
                            </h4>
                            <p className="text-base text-amber-900 font-arabic text-right leading-relaxed">
                              {highlightText(detail.irob, searchQuery)}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>

      {/* Footer */}
      <div className="mt-8 text-center">
        <div className="w-32 h-1 bg-amber-900 mx-auto mb-4"></div>
        <p className="text-amber-900 font-serif">
          ✧ Made with Love -{" "}
          <a href="https://www.fauzanlubis.com">fauzanlubis.com</a> ✧
        </p>
      </div>
    </div>
  );
};

export default App;
